// @ts-nocheck
import * as React from "react";

const HomePin: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" focusable="false" aria-hidden="true">
            <path
                fill="currentColor"
                d="M21.5 10.468a.79.79 0 0 1-1.127.08l-.332-.295v7.846c0 1.32-1.05 2.394-2.342 2.394h-2.813c.236-.247.486-.522.738-.82q.33-.39.618-.776h1.457a.79.79 0 0 0 .78-.798V8.867l-5.814-5.163a1 1 0 0 0-1.328 0L5.522 8.867v9.232c0 .44.35.798.78.798H7.76q.287.386.617.777c.252.297.503.572.739.82H6.302c-1.29 0-2.341-1.075-2.341-2.395v-7.846l-.332.295a.79.79 0 1 1-1.05-1.182l8.758-7.777a1 1 0 0 1 1.328 0l8.758 7.777a.79.79 0 0 1 .077 1.102m-9.5 2.4c-.646 0-1.17.535-1.17 1.197 0 .66.524 1.197 1.17 1.197.648 0 1.172-.536 1.172-1.197 0-.662-.524-1.197-1.171-1.197m4.488 1.439c0 1.267-.687 2.72-2.044 4.321a17.6 17.6 0 0 1-1.95 1.962L12 21l-.493-.41c-.04-.033-.99-.828-1.95-1.962-1.357-1.6-2.045-3.054-2.045-4.321v-.24c0-2.53 2.013-4.588 4.488-4.588 2.474 0 4.487 2.059 4.487 4.589zm-1.56-.24c0-1.65-1.314-2.991-2.927-2.991-1.614 0-2.926 1.342-2.926 2.992v.239c0 .847.59 2.01 1.662 3.276.465.549.931 1.013 1.266 1.328 1.117-1.047 2.924-3.065 2.924-4.604z"
            />
        </svg>
    );
};

export default React.memo(HomePin);
